<template>
	<div class="change">
		<div class="change__brand">
			<SearchBrand ref="searchBrand" @change="setBrandId($event)" />
		</div>
		<p class="change__name">
			선택 브랜드 : <span class="change__title">{{ brandTitle }}</span>
		</p>
		<div class="change__button">
			<button class="btn border" @click="init">초기화</button>
			<button class="btn blue" @click="brandChange">일괄 변경</button>
		</div>
	</div>
</template>
<script>
	import SearchBrand from '@/components/SearchBrand';

	export default {
		data() {
			return {
				brandId: '',
				brandTitle: '',
			};
		},
		components: {
			SearchBrand,
		},
		methods: {
			setBrandId(event) {
				this.brandId = event.idBrand;
				this.brandTitle = event.brandTitle;
			},
			init() {
				this.brandTitle = '';
				this.$refs.searchBrand.init();
			},
			async brandChange() {
				if (!confirm(`브랜드를 ${this.brandTitle}로 일괄 이동할까요?`))
					return;
				await this.$store.dispatch(
					'productList/changeBrandBatch',
					this.brandId
				);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.change {
		&__brand {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 20px;
		}

		&__name {
			font-size: 14px;
			margin-top: 20px;
		}

		&__title {
			font-size: 18px;
			color: $red;
		}

		&__button {
			margin-top: 20px;
			display: flex;
			justify-content: center;
			gap: 20px;
			button {
				width: 120px;
				height: 40px;
				font-size: 16px;
			}
		}
	}
</style>
